"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.actionCreators = {
    requestAuthentication: function (requestBody) { return function (dispatch, getState) {
        var appState = getState();
        if (appState && appState.authentication && requestBody !== appState.authentication.requestBody) {
            fetch("/v1/auth", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(requestBody),
            })
                .then(function (response) {
                if (!response.ok) {
                    throw new Error(JSON.stringify(response.json()));
                }
                return response.json();
            })
                .then(function (data) {
                localStorage.setItem('FOCUSONE_API_GATEWAY', JSON.stringify(data));
                dispatch({ type: 'RECEIVE_AUTHENTITION', requestBody: requestBody, response: data, responseCode: 200 });
            })
                .catch(function (error) {
                dispatch({ type: 'RECEIVE_AUTHENTITION', requestBody: requestBody, response: error, responseCode: 400, errormessage: "Authetication fail" });
            });
            dispatch({ type: 'REQUEST_AUTHENTITION', requestBody: requestBody });
        }
    }; }
};
var unloadedState = { isLoading: false };
exports.reducer = function (state, incomingAction) {
    if (state === undefined) {
        return unloadedState;
    }
    var action = incomingAction;
    switch (action.type) {
        case 'REQUEST_AUTHENTITION':
            return {
                requestBody: action.requestBody,
                response: state.response,
                isLoading: true
            };
        case 'RECEIVE_AUTHENTITION':
            if (action.requestBody === state.requestBody) {
                return {
                    requestBody: action.requestBody,
                    response: action.response,
                    isLoading: false
                };
            }
            break;
    }
    return state;
};
//# sourceMappingURL=Authentication.js.map